"use client";

import { motion, useInView } from "framer-motion";
import { useLocale } from "next-intl";
import { usePathname } from "next/navigation";
import { FC, useEffect, useRef, useState } from "react";

import { DataGrid as DataGridType } from "@/components/UnitGallery/type";
import Icon from "@/components/ui/Icon/Icon";

import "./DataGrid.css";

interface DataGridProps {
  entry: DataGridType;
  animation?: boolean;
  indexKey?: number;
}

const DataGrid: FC<DataGridProps> = ({ entry, animation, indexKey }) => {
  const componentRef = useRef<HTMLUListElement>(null);
  const [isSo, setIsSo] = useState<boolean>(false);
  const locale = useLocale();
  const pathname = usePathname();
  const isInView = useInView(componentRef);
  const [hasAnimated, setHasAnimated] = useState(false);

  const fadeVariants = {
    visible: { opacity: 1, y: 0, transition: { delay: indexKey, duration: 1, ease: "easeInOut" } },
    hidden: { opacity: 0, y: 20 },
  };

  useEffect(() => {
    if (isInView && !hasAnimated && animation) {
      setHasAnimated(true);
    }
  }, [isInView, hasAnimated, animation]);
  useEffect(() => {
    if (typeof window !== "undefined") {
      const value = localStorage?.getItem("isSo");
      if (value) {
        setIsSo(value === "true");
      }
    }
  }, []);

  const isHomePage = pathname === "/" || pathname === `/${locale}/`;
  if (isSo && isHomePage) {
    return null;
  }

  return (
    <motion.ul
      ref={componentRef}
      className="flex flex-wrap px-m items-start justify-between gap-y-l py-[40px] md:px-[40px] md:py-0 md:w-20\/24 mx-auto"
      initial={animation ? "hidden" : ""}
      animate={animation ? (hasAnimated ? "visible" : "hidden") : "visible"}
      variants={fadeVariants}
    >
      {entry.icons.map((item, i) => (
        <li className={`flex flex-1 basis-1/2 md:basis-1/3 justify-center pt-l`} key={`${item.id}-${i}`}>
          <div className="flex flex-col items-center">
            {item.icon && <Icon className="stroke-gold" name={item.icon as string} size="80" />}

            {/* {item.icon?.link?.icon && <Icon className="stroke-gold" name={item.icon.link.icon} size="56" />} */}
            <p className="font-medium text-center  font-primary text-l md:text-xl mb-0 mt-s pt-3xs">{item.title}</p>
            <p className="text-center font-secondary mt-[2px] px-s md:px-0 text-m font-secondary-light">{item.subtitle}</p>
          </div>
        </li>
      ))}
    </motion.ul>
  );
};

export default DataGrid;
